module.exports = __webpack_public_path__ + "img/transvie.3fdcd31b.png";